export const UI_MESSAGE_TYPE = {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  SUCCESS: 'success',
} as const

export type UiMessageType =
  (typeof UI_MESSAGE_TYPE)[keyof typeof UI_MESSAGE_TYPE]
